export default {"src":"__ASTRO_ASSET_IMAGE__yl9_$5sm__","width":131,"height":161,"format":"svg"}